import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useLocaleNavigate } from "@ct-react/locale";
import { useVisitor } from "@ct-react/visitor";
import { User } from "@shared/models/user";
import { CartCustomer } from "../../../models/cart";
import { useLazyLocalFetcher } from "../../../hooks/local-fetcher";
import { interhomeUrlParams, useInterhomeContext } from "./interhome-outlet";
import PaymentInformationForm from "../../../components/forms/payment-information";
import { cartTranslations } from "../../../i18n/sharable-defs";

const InterhomeInformationPage = () => {

  const intl = useIntl();
  const navigate = useLocaleNavigate();
  const { userId } = useVisitor();

  const [ ctx, dispatch ] = useInterhomeContext();
  const [ editable, setEditable ] = useState<CartCustomer | undefined>(undefined);
  const [ validForm, setValidForm ] = useState<boolean>(false);

  useEffect(() => {

    if (!ctx.index) onNavigate("external/cart/interhome")
    else dispatch({ type: "change.index", payload: 2 });

    if (!!userId && !ctx.customer) getUserProfile().then(profile => setEditable(profile as CartCustomer));
    else setEditable(ctx.customer);

  }, []);

  const [ getUserProfile ] = useLazyLocalFetcher<User>("user");

  const onContactEdited = (payload: CartCustomer, isValid: boolean) => {
    isValid && dispatch({ type: "change.customer", payload });
    (validForm !== isValid) && setValidForm(isValid);
  }

  const onNavigate = (page: string) => {
    const params = interhomeUrlParams(ctx.item.articleId, ctx.item.period);
    navigate(`${page}?${params}`);
  }

  return (
    <div className="cart-item-wrapper">

      <PaymentInformationForm className="rl-two-col"
                              withGreeting={true}
                              withMandatoryMobile={true}
                              data={editable}
                              onChange={onContactEdited} />

      <div className="rl-two-col stepper-actions">
        <button type="button"
                className="step-btn back"
                onClick={onNavigate.bind(this, "external/cart/interhome/")}>
          {intl.formatMessage(cartTranslations.backCart)}
        </button>
        <button type="button"
                className="step-btn"
                disabled={!validForm}
                onClick={onNavigate.bind(this, "external/cart/interhome/payment")}>
          {intl.formatMessage(cartTranslations.nextPayment)}
        </button>
      </div>

    </div>);

}

export default InterhomeInformationPage;
